import { ArrowsLeftRightIcon, ArrowUDownLeftIcon, PackageIcon } from '@phosphor-icons/react'

import { outboundExchangeKey, parcelTypes } from '@/parcels/constants'

export const itemsLabelKeys = {
  singular: '1 artículo',
  plural: '{{count}} artículos',
}

export const pendingAlertsLabelKeys = {
  singular: '1 alerta pendiente',
  plural: '{{count}} alertas pendientes',
}

export const parcelCardTypeInfo = {
  [parcelTypes.inbound]: {
    Icon: ArrowUDownLeftIcon,
    labelKey: 'Devolución #{{number}}',
  },
  [outboundExchangeKey]: {
    Icon: ArrowsLeftRightIcon,
    labelKey: 'Cambio #{{number}}',
  },
  [parcelTypes.outbound]: {
    Icon: PackageIcon,
    labelKey: 'Envío #{{number}}',
  },
}
